import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// Experiment Keys:
// 👇 example key (currently deprecated)
// export const EXAMPLE_FLAG = 'example-flag;
// keep for cookie value?
export const HERO_MASTERBRAND_3 = 'homepage-hero-masterbrand-3'; // https://newamsterdamlabs.atlassian.net/browse/CE-1383
export const AUTH_FORM_V2 = 'auth-form-v2'; // INSPO-4327
export const HOLIDAY_2021 = 'holidays2021'; // https://newamsterdamlabs.atlassian.net/browse/CE-1394
export const SHOP_HOLIDAY_2021 = 'shop-holidays2021'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-922
export const MOBILE_NAV_PREAUTH = 'mobile-nav-preauth'; // https://newamsterdamlabs.atlassian.net/browse/CE-1518
export const MOBILE_NAV_POSTAUTH = 'mobile-nav-postauth'; // https://newamsterdamlabs.atlassian.net/browse/CE-1518

const FALLBACK_VARIATIONS = {
  // 👇 example variation (currently deprecated)
  // [EXAMPLE_FLAG]: experimentFlagsHelper.createExperimentFlags(),
  [HERO_MASTERBRAND_3]: experimentFlagsHelper.createExperimentFlags(),
  [AUTH_FORM_V2]: experimentFlagsHelper.createExperimentFlags(),
  [HOLIDAY_2021]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAY_2021]: experimentFlagsHelper.createExperimentFlags(),
  [MOBILE_NAV_PREAUTH]: experimentFlagsHelper.createExperimentFlags(),
  [MOBILE_NAV_POSTAUTH]: experimentFlagsHelper.createExperimentFlags(),
};

const {
  getFlag,
  getExperimentVariation,
  isUnderTest,
  isInExperiment,
} = experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);

export default {
  getExperimentVariation,
  isUnderTest,
  getFlag,
  isInExperiment,
};
